import React, {useState, useEffect, Fragment} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import {NavLink} from 'react-router-dom';
import {getMediaPath, parseUrlParams} from "../../app/functions";

import './index.scss';

import * as Actions from '../../redux/actions';
import * as Routes from '../../constants/routes';

//assets
import logo from 'assets/logos/hot-new.svg';
import smiley from 'assets/icons/survey/smiley.svg';
import sad from 'assets/icons/survey/sad.svg';
import content from 'assets/icons/survey/content.svg';
import smiley_selected from 'assets/icons/survey/smiley-selected.svg';
import sad_selected from 'assets/icons/survey/sad-selected.svg';
import content_selected from 'assets/icons/survey/content-selected.svg';
import watch from 'assets/icons/watch.svg';

//mock
const imagesArr = [{grey: getMediaPath(sad), colored: getMediaPath(sad_selected)}, {grey: getMediaPath(content), colored: getMediaPath(content_selected)}, {grey: getMediaPath(smiley), colored: getMediaPath(smiley_selected)}];

let request_survey = true;

let hash = null;


const Survey = (props) =>{

    const text = useSelector(store => store.config.Translations);
    const survey = useSelector(store => store.config.Survey);
    const surveyStatus = useSelector(store => store.state.surveyStatus);
    const orderNotReceived = useSelector(store => store.data.OrderNotReceived);

    const dispatch = useDispatch();

    const [step, setStep] = useState(1);
    const [answers, setAnswers] = useState({0:-1, 1: -1, 2:-1});

    useEffect(() => {
        // get url params and request for the survey
        if (request_survey) {
            const urlParams = new URLSearchParams(window.location.search);
            hash = urlParams.get('hash');
            dispatch(Actions.getCustomerSurvey({hash: hash}));
            request_survey = false;
        }

        //survey is sent successfully
        if (surveyStatus)
            setStep(3);

        if (orderNotReceived)
            setStep(4);

        let state = {};

        if (survey) {
            for (let key in survey.questions) {
                state[key] = -1;
            }
        }

        setAnswers(state);

    }, [survey, surveyStatus, orderNotReceived]);
    
    const getContent = () => {
        let elementToRender = null;

        switch (step) {
            case 1:
                elementToRender = getPersonalDetails();
                break;
            case 2:
                elementToRender = getSurvey();
                break;
            default:break;
        }

        return elementToRender;
    };

    const handleSmileyClick = (question_id, answer_id) =>{
        setAnswers({...answers, [question_id] : answer_id});
    };

    const checkIfValidForm = () =>{
        let send = true;

        for (let key in answers){
            if (parseInt(answers[key]) === -1) {
                send = false;
            }
        }

        return send;
    };

    const handleSendClick = () =>{

        const send = checkIfValidForm();

        if (send) {
            const urlParams = new URLSearchParams(window.location.search);
            const hash = urlParams.get('hash');


            dispatch(Actions.answerCustomerSurvey({
                hash: hash,
                data: JSON.stringify(answers),
            }));
        }
    };
    
    const getSurvey = () =>{
        let res = [];

        for (let key in survey.questions){
            res.push(
                <div key={key} className='box question'>
                    <span className='title'>{survey.questions[key]}</span>
                    <div className='options-container'>
                        {imagesArr.map((option, index) =>{
                            const selected = index === answers[key];
                            return <div className='option' onClick={() => handleSmileyClick(key, index)}><img src={selected ? option.colored : option.grey} alt='/'/></div>;
                        })}
                    </div>
                </div>
            )
        }

        return res;
    };

    const getPersonalDetails = () =>{
        return(
          <div className='box'>
              <span className='title'>{text['survey_order_details']}</span>
              <div className='details-wrap'>
                  <span>מספר הזמנה</span>
                  <span>{survey.order_id}</span>
              </div>
              <div className='details-wrap'>
                  <span>{text['survey_product_name']}</span>
                  <span>{survey.supplier_title}</span>
              </div>
          </div>
        );
    };

    const getTitle = () =>{

        const title = ['היי ' + survey.customer_first_name + ' ' + survey.customer_last_name, text['survey_title_step2'], text['survey_title_step3'], survey.customer_first_name + ' ' + survey.customer_last_name + ','];
        const desc = [text['survey_desc_step1'], text['survey_desc_step2'], text['survey_desc_step3'], text['survey_desc_step4']];

        return(
            <div className={'title-wrap step' + step}>
                {step === 4 && <img src={getMediaPath(watch)} alt=''/>}
                <h2>{title[step - 1]}</h2>
                <span>{desc[step - 1]}</span>
            </div>
        );

    };

    const getButtons = () =>{
        let firstBtn = {text:'', action: null, active:false, disabled: false};
        let secondBtn = {text:'', action: null, active:false};

        switch (step){
            case 1:{
                firstBtn.text = text['survey_first_btn_text_step1'];
                firstBtn.action = ()=> setStep(2);
                firstBtn.active = true;
                secondBtn.text = text['survey_second_btn_text_step1'];
                // secondBtn.action = ()=> setStep(4);
                secondBtn.action = () => dispatch(Actions.orderNotReceivedReply({hash:hash}));
                secondBtn.active = true;
                break;
            }
            case 2:{
                firstBtn.text = text['survey_first_btn_text_step2'];
                firstBtn.action = handleSendClick;
                firstBtn.active = true;
                firstBtn.disabled = !checkIfValidForm();
                break;
            }
            default:break;
        }

        return(
            <div className='button-container'>
                {firstBtn.active && <button className={'continue-btn survey-btn ' + (firstBtn.disabled ? 'disabled' : '') } onClick={firstBtn.action}>{firstBtn.text}</button>}
                {secondBtn.active && <button className='error-btn survey-btn' onClick={secondBtn.action}>{secondBtn.text}</button>}
            </div>
        )
    };

    return(
      <section className='survey'>
          {survey &&
          <Fragment>
              <NavLink to={Routes.home} className={'head step' + step}>
                  <img src={getMediaPath(logo)} alt=''/>
              </NavLink>

              {getTitle()}

              <div className='content'>
                  {getContent()}
              </div>

              {getButtons()}
          </Fragment>
          }
      </section>
    );
};

export default Survey;